const EXCEL_BOM = "\uFEFF";

function escapeCsvValue(value) {
  if (value === null || value === undefined) return "";
  const str = String(value);
  // Escape if value contains comma, quote, or newline
  if (/[",\n\r]/.test(str)) {
    return `"${str.replace(/"/g, '""')}"`;
  }
  return str;
}

/**
 * Convert an array of objects into a CSV string.
 * @param {Array<Record<string, any>>} rows
 * @param {Array<{ key: string, label: string }>} columns
 */
export function objectsToCsv(rows, columns) {
  const safeRows = Array.isArray(rows) ? rows : [];
  const safeCols = Array.isArray(columns) ? columns : [];

  const header = safeCols.map((c) => escapeCsvValue(c.label)).join(",");
  const lines = safeRows.map((row) =>
    safeCols.map((c) => escapeCsvValue(row?.[c.key])).join(","),
  );

  // Add BOM for Excel compatibility
  return `${EXCEL_BOM}${header}\n${lines.join("\n")}\n`;
}

export function downloadTextFile({ filename, text, mimeType }) {
  const safeName = filename || `download-${Date.now()}.txt`;
  const safeText = typeof text === "string" ? text : "";
  const type = mimeType || "text/plain;charset=utf-8";

  const blob = new Blob([safeText], { type });
  const url = URL.createObjectURL(blob);

  const a = document.createElement("a");
  a.href = url;
  a.download = safeName;
  document.body.appendChild(a);
  a.click();

  setTimeout(() => {
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
  }, 100);
}


